'use strict'

import React,{Component} from 'react';

import priority from '../../app/utils/priority.js';
import FormattedContent from './../components/FormattedContent.jsx';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);


class IssueReportEntry extends Component {
  constructor(props) {
  	super(props);
  	this.state = {hover: false};
  }

  toggleHover(event) {
    event.preventDefault();
	   this.setState({hover: !this.state.hover});
   }


  selectItem() {
    if (!this.props.item.readOnly && this.props.onSelect!==undefined) {
      this.props.onSelect(this.props.item);
    }
  }

  render() {
    let labels=translations.getTranslation(this.props).general.status;
    var item=this.props.item;
    var bgColor=this.state.hover ? "#f1fbfe" : this.props.backgroundColor;
    var status=function() {
      switch (item._progress) {
        case "Capture": return labels.captured;
        case "Examine": return labels.examined;
        case "Propose": return labels.proposed;
        case "Decide": return labels.decided;
        case "Implement": return labels.implemented;
      }
    }();
    return (
      <div onClick={this.selectItem.bind(this)} onMouseEnter={this.toggleHover.bind(this)} onMouseLeave={this.toggleHover.bind(this)} style={{cursor:item.readOnly!==true ? "pointer" : undefined, display:"table-row", backgroundColor: bgColor, borderBottom:"solid 1px #939393", color:item.status==="Closed" ? "lightgrey" : item.readOnly ? "#505050" : "#212121", textDecoration:item.status==="Closed" ? "line-through" : "none"}}>

        <div style={{paddingTop:2, paddingLeft:7, paddingRight:5}}>
          <div style={{display:"table-cell,inline-block", marginTop:4, padding:8, borderRadius:"50%", width:0, hight:15, backgroundColor:priority.priorityColor(item,this.props.profile) }}> </div>
        </div>
        <div style={{display:"table-cell", textAlign:"center", padding:5}}>
            {item.no}
        </div>
        <div style={{display:"table-cell", padding:5}}>{item.title}</div>
        <div style={{display:"table-cell", padding:5}}><FormattedContent value={item.impact}/></div>
        <div style={{display:"table-cell", padding:5}}><FormattedContent value={item.recommendation}/></div>
        <div style={{display:"table-cell", padding:5}}><FormattedContent value={item.decision}/></div>
        <div style={{display:"table-cell", padding:5}}>
          {status}
          {item._progress==="Implement" && item.statusUpdated!==undefined ? (
            <div style={{paddingTop:5}}>
              <b>{new Date(item.statusUpdated).toISOString().slice(0,10)}</b>:
              <FormattedContent value={item.statusDescription}/>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default class IssueReportList extends Component {
  render() {
    let labels=translations.getTranslation(this.props).report.columns;
    return (
      <div style={{display:"table", borderCollapse:"collapse", width:"100%"}}>
        <div style={{display: "table-row", borderBottom:"solid 1px #939393", pageBreakInside:"avoid", backgroundColor:"#ffffff", color:"#212121", fontWeight:"bold", textAlign:"left"}}>
          <div style={{display:"table-cell", paddingTop:5, paddingBottom:5, paddingLeft:10, pageBreakInside:"avoid"}}></div>
          <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.id}</div>
          <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.title}</div>
          <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.impact}</div>
          <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.recommendation}</div>
          <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.decision}</div>
          <div style={{display:"table-cell", padding:5, pageBreakInside:"avoid"}}>{labels.status}</div>
        </div>
        {this.props.items.map((item,index)=><IssueReportEntry key={index} {...this.props} language={this.props.language} onSelect={this.props.onSelect} backgroundColor={index%2===1 ? "#f7f7f7" : "white"} item={item}/>)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/change/IssueReportList.jsx